import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/secretsProvider.ee.ts
const getSecretProviderTypes = async (context) => {
	return await makeRestApiRequest(context, "GET", "/secret-providers/types");
};
const getSecretProviderConnections = async (context) => {
	return await makeRestApiRequest(context, "GET", "/secret-providers/connections");
};
const getSecretProviderConnectionByKey = async (context, providerKey) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/connections/${providerKey}`);
};
const createSecretProviderConnection = async (context, data) => {
	return await makeRestApiRequest(context, "POST", "/secret-providers/connections", data);
};
const updateSecretProviderConnection = async (context, providerKey, data) => {
	return await makeRestApiRequest(context, "PATCH", `/secret-providers/connections/${providerKey}`, data);
};
const testSecretProviderConnection = async (context, providerKey) => {
	return await makeRestApiRequest(context, "POST", `/secret-providers/connections/${providerKey}/test`);
};
const reloadSecretProviderConnection = async (context, providerKey) => {
	return await makeRestApiRequest(context, "POST", `/secret-providers/connections/${providerKey}/reload`);
};
const deleteSecretProviderConnection = async (context, providerKey) => {
	return await makeRestApiRequest(context, "DELETE", `/secret-providers/connections/${providerKey}`);
};
const getProjectSecretProviderConnectionsByProjectId = async (context, projectId) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/projects/${projectId}/connections`);
};
const getProjectSecretProviderConnectionByKey = async (context, projectId, providerKey) => {
	return await makeRestApiRequest(context, "GET", `/secret-providers/projects/${projectId}/connections/${providerKey}`);
};
const createProjectSecretProviderConnection = async (context, projectId, data) => {
	return await makeRestApiRequest(context, "POST", `/secret-providers/projects/${projectId}/connections`, data);
};
const updateProjectSecretProviderConnection = async (context, projectId, providerKey, data) => {
	return await makeRestApiRequest(context, "PATCH", `/secret-providers/projects/${projectId}/connections/${providerKey}`, data);
};
const testProjectSecretProviderConnection = async (context, projectId, providerKey) => {
	return await makeRestApiRequest(context, "POST", `/secret-providers/projects/${projectId}/connections/${providerKey}/test`);
};
const deleteProjectSecretProviderConnection = async (context, projectId, providerKey) => {
	return await makeRestApiRequest(context, "DELETE", `/secret-providers/projects/${projectId}/connections/${providerKey}`);
};

//#endregion
export { getProjectSecretProviderConnectionByKey as a, getSecretProviderConnections as c, testProjectSecretProviderConnection as d, testSecretProviderConnection as f, deleteSecretProviderConnection as i, getSecretProviderTypes as l, updateSecretProviderConnection as m, createSecretProviderConnection as n, getProjectSecretProviderConnectionsByProjectId as o, updateProjectSecretProviderConnection as p, deleteProjectSecretProviderConnection as r, getSecretProviderConnectionByKey as s, createProjectSecretProviderConnection as t, reloadSecretProviderConnection as u };
//# sourceMappingURL=secretsProvider.ee.mjs.map